<template>
  <p class="c-title-medium">
    <slot />
  </p>
</template>

<style lang="scss" scoped>
.c-title-medium {
  @include text__title--m;
  line-height: (33/24);

  @include sp {
    @include text__body--l;
  }
}
</style>
